import { render, staticRenderFns } from "./ClientStockRateEditComponent.vue?vue&type=template&id=16b77f33"
import script from "./ClientStockRateEditComponent.vue?vue&type=script&lang=js"
export * from "./ClientStockRateEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientStockRateEditComponent.vue?vue&type=style&index=0&id=16b77f33&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports